<template lang="pug">
  component.ancestor(:is="tag" v-bind="props") {{ item.title }}
</template>

<script>
export default {
  name: 'Ancestor',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    tag() {
      let tag = 'div';
      if (this.item.disabled === false && this.item.page.view.includes(['Folder']) === false) tag = 'router-link';
      return tag;
    },
    props() {
      let props = {};
      if (this.tag === 'router-link') props.to = this.item.path;
      return props;
    }
  }
};
</script>
